import {
    FETCH_SALES_WALKTHROUGH_REQUEST,
    FETCH_SALES_WALKTHROUGH_SUCCESS,
    FETCH_SALES_WALKTHROUGH_FAILURE,
} from "../../../../Constants/actionTypes";

const initialState = {
    salesWalkthrough: [],
    loading: false,
    error: null,
};

const salesWalkthroughReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SALES_WALKTHROUGH_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_SALES_WALKTHROUGH_SUCCESS:
            return {
                ...state,
                loading: false,
                salesWalkthrough: action.payload["tutorial-pages"] || [],
            };

        case FETCH_SALES_WALKTHROUGH_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default salesWalkthroughReducer;
